import React from 'react'

const Footer = () => {
    return <footer>
           <p>Síguenos en: </p>
           <a rel="noreferrer" href="https://www.instagram.com/bungalows_ph/" target="_blank">
                <i className="fab fa-instagram"></i>
            </a> 
            <a rel="noreferrer" href="https://www.facebook.com/bungalowsPH" target="_blank">
                <i className="fab fa-facebook-f"></i>
            </a>
        </footer>
    
}

export default Footer
